import { brochurePages } from '../data/brochurePages'

const DOCUMENT_TITLE = 'Viral Shantivan - Swastik Infra Developer - Brochure'

/**
 * Opens the full brochure as a single, print-ready document sized to
 * landscape A4 — one brochure page per PDF page. The browser's print
 * dialog then saves all pages as one PDF file.
 */
export function downloadBrochurePdf(): void {
  const printWindow = window.open('', '_blank')

  if (!printWindow) {
    // Popup blocked — fall back to opening the first page directly.
    window.open(brochurePages[0].image, '_blank', 'noopener,noreferrer')
    return
  }

  const pagesMarkup = brochurePages
    .map(
      (page) => `
        <section class="page">
          <img src="${page.image}" alt="${page.label} — Viral Shantivan brochure" />
        </section>
      `,
    )
    .join('')

  printWindow.document.write(`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>${DOCUMENT_TITLE}</title>
    <style>
      @page {
        size: A4 landscape;
        margin: 0;
      }
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body {
        background: #f1f5f9;
        font-family: system-ui, -apple-system, sans-serif;
      }
      .hint {
        padding: 16px 20px;
        background: #1e3a8a;
        color: #fff;
        font-size: 14px;
        text-align: center;
      }
      .page {
        width: 297mm;
        height: 210mm;
        margin: 12px auto;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(15, 23, 42, 0.15);
      }
      .page img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
      @media print {
        .hint { display: none; }
        body { background: #fff; }
        .page {
          margin: 0;
          box-shadow: none;
          page-break-after: always;
          break-after: page;
        }
        .page:last-child {
          page-break-after: auto;
          break-after: auto;
        }
      }
    </style>
  </head>
  <body>
    <p class="hint">
      Choose <strong>Save as PDF</strong> as the destination to download the
      complete ${brochurePages.length}-page Viral Shantivan brochure.
    </p>
    ${pagesMarkup}
  </body>
</html>`)

  printWindow.document.close()

  // Wait for every page image to decode before invoking print, so no page
  // comes out blank.
  const images = Array.from(printWindow.document.images)
  Promise.all(
    images.map(
      (img) =>
        new Promise<void>((resolve) => {
          if (img.complete) {
            resolve()
            return
          }
          img.addEventListener('load', () => resolve(), { once: true })
          img.addEventListener('error', () => resolve(), { once: true })
        }),
    ),
  ).then(() => {
    printWindow.focus()
    printWindow.print()
  })
}
